/**
 * Estado de conexión de Staff (006 · T019, research R-20).
 *
 * `useOnlineStatus()` se engancha al `onlineManager` de TanStack Query —el mismo que pausa las
 * consultas sin red y las refresca al volver `online`— y lo combina con `navigator.onLine`: el
 * `onlineManager` de la v5 arranca asumiendo conexión y solo cambia con los eventos
 * `online`/`offline` de `window`, así que una app que **abre** sin red solo se entera por
 * `navigator.onLine`. No se toca el estado global del `onlineManager`: se lee.
 *
 * Nada de lo que se muestra sin conexión sale de un almacenamiento local (wiring 006 §0.7): son los
 * datos ya cargados en memoria durante esta sesión.
 */
import { onlineManager } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  // Suscribirse activa en el `onlineManager` sus oyentes de `online`/`offline` de `window`.
  return onlineManager.subscribe(() => {
    onChange();
  });
}

/** `true` si hay conexión según el `onlineManager` **y** el navegador. */
export function isOnlineNow(): boolean {
  const browserOnline = typeof navigator === 'undefined' || navigator.onLine !== false;
  return onlineManager.isOnline() && browserOnline;
}

/** Hook reactivo: vuelve a pintar al perder o recuperar la conexión. */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, isOnlineNow, () => true);
}
